function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*! @orchidjs/unicode-variants | https://github.com/orchidjs/unicode-variants | Apache License (v2) */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.diacritics = {}));
})(this, function (exports) {
  'use strict';

  /**
   * Convert array of strings to a regular expression
   *	ex ['ab','a'] => (?:ab|a)
   * 	ex ['a','b'] => [ab]
   */
  var _marked = /*#__PURE__*/_regeneratorRuntime().mark(generator);
  var arrayToPattern = function arrayToPattern(chars) {
    chars = chars.filter(Boolean);
    if (chars.length < 2) {
      return chars[0] || '';
    }
    return maxValueLength(chars) == 1 ? '[' + chars.join('') + ']' : '(?:' + chars.join('|') + ')';
  };
  var sequencePattern = function sequencePattern(array) {
    if (!hasDuplicates(array)) {
      return array.join('');
    }
    var pattern = '';
    var prev_char_count = 0;
    var prev_pattern = function prev_pattern() {
      if (prev_char_count > 1) {
        pattern += '{' + prev_char_count + '}';
      }
    };
    array.forEach(function (char, i) {
      if (char === array[i - 1]) {
        prev_char_count++;
        return;
      }
      prev_pattern();
      pattern += char;
      prev_char_count = 1;
    });
    prev_pattern();
    return pattern;
  };

  /**
   * Convert array of strings to a regular expression
   *	ex ['ab','a'] => (?:ab|a)
   * 	ex ['a','b'] => [ab]
   */
  var setToPattern = function setToPattern(chars) {
    var array = Array.from(chars);
    return arrayToPattern(array);
  };

  /**
   * https://stackoverflow.com/questions/7376598/in-javascript-how-do-i-check-if-an-array-has-duplicate-values
   */
  var hasDuplicates = function hasDuplicates(array) {
    return new Set(array).size !== array.length;
  };

  /**
   * https://stackoverflow.com/questions/63006601/why-does-u-throw-an-invalid-escape-error
   */
  var escape_regex = function escape_regex(str) {
    return (str + '').replace(/([\$\(-\+\.\?\[-\^\{-\}])/g, '\\$1');
  };

  /**
   * Return the max length of array values
   */
  var maxValueLength = function maxValueLength(array) {
    return array.reduce(function (longest, value) {
      return Math.max(longest, unicodeLength(value));
    }, 0);
  };
  var unicodeLength = function unicodeLength(str) {
    return Array.from(str).length;
  };

  /**
   * Get all possible combinations of substrings that add up to the given string
   * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
   */
  var allSubstrings = function allSubstrings(input) {
    if (input.length === 1) return [[input]];
    var result = [];
    var start = input.substring(1);
    var suba = allSubstrings(start);
    suba.forEach(function (subresult) {
      var tmp = subresult.slice(0);
      tmp[0] = input.charAt(0) + tmp[0];
      result.push(tmp);
      tmp = subresult.slice(0);
      tmp.unshift(input.charAt(0));
      result.push(tmp);
    });
    return result;
  };
  var code_points = [[0, 65535]];
  var accent_pat = "[\u0300-\u036F\xB7\u02BE\u02BC]";
  exports.unicode_map = void 0;
  var multi_char_reg;
  var max_char_length = 3;
  var latin_convert = {};
  var latin_condensed = {
    '/': '⁄∕',
    '0': '߀',
    "a": "ⱥɐɑ",
    "aa": "ꜳ",
    "ae": "æǽǣ",
    "ao": "ꜵ",
    "au": "ꜷ",
    "av": "ꜹꜻ",
    "ay": "ꜽ",
    "b": "ƀɓƃ",
    "c": "ꜿƈȼↄ",
    "d": "đɗɖᴅƌꮷԁɦ",
    "e": "ɛǝᴇɇ",
    "f": "ꝼƒ",
    "g": "ǥɠꞡᵹꝿɢ",
    "h": "ħⱨⱶɥ",
    "i": "ɨı",
    "j": "ɉȷ",
    "k": "ƙⱪꝁꝃꝅꞣ",
    "l": "łƚɫⱡꝉꝇꞁɭ",
    "m": "ɱɯϻ",
    "n": "ꞥƞɲꞑᴎлԉ",
    "o": "øǿɔɵꝋꝍᴑ",
    "oe": "œ",
    "oi": "ƣ",
    "oo": "ꝏ",
    "ou": "ȣ",
    "p": "ƥᵽꝑꝓꝕρ",
    "q": "ꝗꝙɋ",
    "r": "ɍɽꝛꞧꞃ",
    "s": "ßȿꞩꞅʂ",
    "t": "ŧƭʈⱦꞇ",
    "th": "þ",
    "tz": "ꜩ",
    "u": "ʉ",
    "v": "ʋꝟʌ",
    "vy": "ꝡ",
    "w": "ⱳ",
    "y": "ƴɏỿ",
    "z": "ƶȥɀⱬꝣ",
    "hv": "ƕ"
  };
  for (var latin in latin_condensed) {
    var unicode = latin_condensed[latin] || '';
    for (var i = 0; i < unicode.length; i++) {
      var char = unicode.substring(i, i + 1);
      latin_convert[char] = latin;
    }
  }
  var convert_pat = new RegExp(Object.keys(latin_convert).join('|') + '|' + accent_pat, 'gu');

  /**
   * Initialize the unicode_map from the give code point ranges
   */
  var initialize = function initialize(_code_points) {
    if (exports.unicode_map !== undefined) return;
    exports.unicode_map = generateMap(_code_points || code_points);
  };

  /**
   * Helper method for normalize a string
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
   */
  var normalize = function normalize(str) {
    var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NFKD';
    return str.normalize(form);
  };

  /**
   * Remove accents without reordering string
   * calling str.normalize('NFKD') on \u{594}\u{595}\u{596} becomes \u{596}\u{594}\u{595}
   * via https://github.com/krisk/Fuse/issues/133#issuecomment-318692703
   */
  var asciifold = function asciifold(str) {
    return Array.from(str).reduce(
    /**
     * @param {string} result
     * @param {string} char
     */
    function (result, char) {
      return result + _asciifold(char);
    }, '');
  };
  var _asciifold = function _asciifold(str) {
    str = normalize(str).toLowerCase().replace(convert_pat, function ( /** @type {string} */char) {
      return latin_convert[char] || '';
    });

    //return str;
    return normalize(str, 'NFC');
  };

  /**
   * Generate a list of unicode variants from the list of code points
   */
  function generator(code_points) {
    var _iterator, _step, _ref, _ref2, code_point_min, code_point_max, _i, composed, folded;
    return _regeneratorRuntime().wrap(function generator$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(code_points);
          _context.prev = 1;
          _iterator.s();
        case 3:
          if ((_step = _iterator.n()).done) {
            _context.next = 25;
            break;
          }
          _ref = _step.value;
          _ref2 = _slicedToArray(_ref, 2);
          code_point_min = _ref2[0];
          code_point_max = _ref2[1];
          _i = code_point_min;
        case 9:
          if (!(_i <= code_point_max)) {
            _context.next = 23;
            break;
          }
          composed = String.fromCharCode(_i);
          folded = asciifold(composed);
          if (!(folded == composed.toLowerCase())) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("continue", 20);
        case 14:
          if (!(folded.length > max_char_length)) {
            _context.next = 16;
            break;
          }
          return _context.abrupt("continue", 20);
        case 16:
          if (!(folded.length == 0)) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("continue", 20);
        case 18:
          _context.next = 20;
          return {
            folded: folded,
            composed: composed,
            code_point: _i
          };
        case 20:
          _i++;
          _context.next = 9;
          break;
        case 23:
          _context.next = 3;
          break;
        case 25:
          _context.next = 30;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](1);
          _iterator.e(_context.t0);
        case 30:
          _context.prev = 30;
          _iterator.f();
          return _context.finish(30);
        case 33:
        case "end":
          return _context.stop();
      }
    }, _marked, null, [[1, 27, 30, 33]]);
  }

  /**
   * Generate a unicode map from the list of code points
   */
  var generateSets = function generateSets(code_points) {
    var unicode_sets = {};
    var addMatching = function addMatching(folded, to_add) {
      /** @type {Set<string>} */
      var folded_set = unicode_sets[folded] || new Set();
      var patt = new RegExp('^' + setToPattern(folded_set) + '$', 'iu');
      if (to_add.match(patt)) {
        return;
      }
      folded_set.add(escape_regex(to_add));
      unicode_sets[folded] = folded_set;
    };
    var _iterator2 = _createForOfIteratorHelper(generator(code_points)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var value = _step2.value;
        addMatching(value.folded, value.folded);
        addMatching(value.folded, value.composed);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return unicode_sets;
  };

  /**
   * Generate a unicode map from the list of code points
   * ae => (?:(?:ae|Æ|Ǽ|Ǣ)|(?:A|Ⓐ|Ａ...)(?:E|ɛ|Ⓔ...))
   */
  var generateMap = function generateMap(code_points) {
    var unicode_sets = generateSets(code_points);
    var unicode_map = {};
    var multi_char = [];
    for (var folded in unicode_sets) {
      var set = unicode_sets[folded];
      if (set) {
        unicode_map[folded] = setToPattern(set);
      }
      if (folded.length > 1) {
        multi_char.push(escape_regex(folded));
      }
    }
    multi_char.sort(function (a, b) {
      return b.length - a.length;
    });
    var multi_char_patt = arrayToPattern(multi_char);
    multi_char_reg = new RegExp('^' + multi_char_patt, 'u');
    return unicode_map;
  };

  /**
   * Map each element of an array from its folded value to all possible unicode matches
   */
  var mapSequence = function mapSequence(strings) {
    var min_replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var chars_replaced = 0;
    strings = strings.map(function (str) {
      if (exports.unicode_map[str]) {
        chars_replaced += str.length;
      }
      return exports.unicode_map[str] || str;
    });
    if (chars_replaced >= min_replacement) {
      return sequencePattern(strings);
    }
    return '';
  };

  /**
   * Convert a short string and split it into all possible patterns
   * Keep a pattern only if min_replacement is met
   *
   * 'abc'
   * 		=> [['abc'],['ab','c'],['a','bc'],['a','b','c']]
   *		=> ['abc-pattern','ab-c-pattern'...]
   */
  var substringsToPattern = function substringsToPattern(str) {
    var min_replacement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    min_replacement = Math.max(min_replacement, str.length - 1);
    return arrayToPattern(allSubstrings(str).map(function (sub_pat) {
      return mapSequence(sub_pat, min_replacement);
    }));
  };

  /**
   * Convert an array of sequences into a pattern
   * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
   */
  var sequencesToPattern = function sequencesToPattern(sequences) {
    var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var min_replacement = sequences.length > 1 ? 1 : 0;
    return arrayToPattern(sequences.map(function (sequence) {
      var seq = [];
      var len = all ? sequence.length() : sequence.length() - 1;
      for (var j = 0; j < len; j++) {
        seq.push(substringsToPattern(sequence.substrs[j] || '', min_replacement));
      }
      return sequencePattern(seq);
    }));
  };

  /**
   * Return true if the sequence is already in the sequences
   */
  var inSequences = function inSequences(needle_seq, sequences) {
    var _iterator3 = _createForOfIteratorHelper(sequences),
      _step3;
    try {
      var _loop = function _loop() {
        var seq = _step3.value;
        if (seq.start != needle_seq.start || seq.end != needle_seq.end) {
          return "continue";
        }
        if (seq.substrs.join('') !== needle_seq.substrs.join('')) {
          return "continue";
        }
        var needle_parts = needle_seq.parts;
        var filter = function filter(part) {
          var _iterator4 = _createForOfIteratorHelper(needle_parts),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var needle_part = _step4.value;
              if (needle_part.start === part.start && needle_part.substr === part.substr) {
                return false;
              }
              if (part.length == 1 || needle_part.length == 1) {
                continue;
              }

              // check for overlapping parts
              // a = ['::=','==']
              // b = ['::','===']
              // a = ['r','sm']
              // b = ['rs','m']
              if (part.start < needle_part.start && part.end > needle_part.start) {
                return true;
              }
              if (needle_part.start < part.start && needle_part.end > part.start) {
                return true;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return false;
        };
        var filtered = seq.parts.filter(filter);
        if (filtered.length > 0) {
          return "continue";
        }
        return {
          v: true
        };
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _ret = _loop();
        if (_ret === "continue") continue;
        if (_typeof(_ret) === "object") return _ret.v;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return false;
  };
  var Sequence = /*#__PURE__*/function () {
    function Sequence() {
      _classCallCheck(this, Sequence);
      this.parts = [];
      this.substrs = [];
      this.start = 0;
      this.end = 0;
    }
    _createClass(Sequence, [{
      key: "add",
      value: function add(part) {
        if (part) {
          this.parts.push(part);
          this.substrs.push(part.substr);
          this.start = Math.min(part.start, this.start);
          this.end = Math.max(part.end, this.end);
        }
      }
    }, {
      key: "last",
      value: function last() {
        return this.parts[this.parts.length - 1];
      }
    }, {
      key: "length",
      value: function length() {
        return this.parts.length;
      }
    }, {
      key: "clone",
      value: function clone(position, last_piece) {
        var clone = new Sequence();
        var parts = JSON.parse(JSON.stringify(this.parts));
        var last_part = parts.pop();
        var _iterator5 = _createForOfIteratorHelper(parts),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var part = _step5.value;
            clone.add(part);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        var last_substr = last_piece.substr.substring(0, position - last_part.start);
        var clone_last_len = last_substr.length;
        clone.add({
          start: last_part.start,
          end: last_part.start + clone_last_len,
          length: clone_last_len,
          substr: last_substr
        });
        return clone;
      }
    }]);
    return Sequence;
  }();
  /**
   * Expand a regular expression pattern to include unicode variants
   * 	eg /a/ becomes /aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑAⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ/
   *
   * Issue:
   *  ﺊﺋ [ 'ﺊ = \\u{fe8a}', 'ﺋ = \\u{fe8b}' ]
   *	becomes:	ئئ [ 'ي = \\u{64a}', 'ٔ = \\u{654}', 'ي = \\u{64a}', 'ٔ = \\u{654}' ]
   *
   *	İĲ = IIJ = ⅡJ
   *
   * 	1/2/4
   */
  var getPattern = function getPattern(str) {
    initialize();
    str = asciifold(str);
    var pattern = '';
    var sequences = [new Sequence()];
    for (var _i2 = 0; _i2 < str.length; _i2++) {
      var substr = str.substring(_i2);
      var match = substr.match(multi_char_reg);
      var _char = str.substring(_i2, _i2 + 1);
      var match_str = match ? match[0] : null;

      // loop through sequences
      // add either the char or multi_match
      var overlapping = [];
      var added_types = new Set();
      var _iterator6 = _createForOfIteratorHelper(sequences),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var sequence = _step6.value;
          var last_piece = sequence.last();
          if (!last_piece || last_piece.length == 1 || last_piece.end <= _i2) {
            // if we have a multi match
            if (match_str) {
              var len = match_str.length;
              sequence.add({
                start: _i2,
                end: _i2 + len,
                length: len,
                substr: match_str
              });
              added_types.add('1');
            } else {
              sequence.add({
                start: _i2,
                end: _i2 + 1,
                length: 1,
                substr: _char
              });
              added_types.add('2');
            }
          } else if (match_str) {
            var _clone = sequence.clone(_i2, last_piece);
            var _len = match_str.length;
            _clone.add({
              start: _i2,
              end: _i2 + _len,
              length: _len,
              substr: match_str
            });
            overlapping.push(_clone);
          } else {
            // don't add char
            // adding would create invalid patterns: 234 => [2,34,4]
            added_types.add('3');
          }
        }

        // if we have overlapping
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      if (overlapping.length > 0) {
        // ['ii','iii'] before ['i','i','iii']
        overlapping = overlapping.sort(function (a, b) {
          return a.length() - b.length();
        });
        var _iterator7 = _createForOfIteratorHelper(overlapping),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var clone = _step7.value;
            // don't add if we already have an equivalent sequence
            if (inSequences(clone, sequences)) {
              continue;
            }
            sequences.push(clone);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
        continue;
      }

      // if we haven't done anything unique
      // clean up the patterns
      // helps keep patterns smaller
      // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
      if (_i2 > 0 && added_types.size == 1 && !added_types.has('3')) {
        pattern += sequencesToPattern(sequences, false);
        var new_seq = new Sequence();
        var old_seq = sequences[0];
        if (old_seq) {
          new_seq.add(old_seq.last());
        }
        sequences = [new_seq];
      }
    }
    pattern += sequencesToPattern(sequences, true);
    return pattern;
  };
  exports._asciifold = _asciifold;
  exports.asciifold = asciifold;
  exports.code_points = code_points;
  exports.escape_regex = escape_regex;
  exports.generateMap = generateMap;
  exports.generateSets = generateSets;
  exports.generator = generator;
  exports.getPattern = getPattern;
  exports.initialize = initialize;
  exports.mapSequence = mapSequence;
  exports.normalize = normalize;
  exports.substringsToPattern = substringsToPattern;
});